// Supplier memory is authoritative for operational units. OCR quantities and
// prices belong to this delivery; OCR units must not reinterpret a saved match.
// Keep the Edge mirror in supabase/functions/_shared identical.
export interface SupplierUnitMemory {
  food_id: string;
  supplier_code: string | null;
  raw_description_norm: string | null;
  pack_factor?: number | null;
  pack_uom?: string | null;
  base_uom?: string | null;
}

export function resolveSupplierUnitMemory(
  rows: SupplierUnitMemory[],
  line: { foodId: string; foodUom: string; supplierCode?: string | null; descriptions: (string | null | undefined)[] },
): { factor: number; sourceUom: string; stockUom: string } | null {
  const norm = (value: string | null | undefined) => (value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  const code = norm(line.supplierCode);
  const byCode = code ? rows.filter(row => norm(row.supplier_code) === code) : [];
  const descriptions = new Set(line.descriptions.map(norm).filter(Boolean));
  const matches = byCode.length ? byCode : rows.filter(row =>
    descriptions.has(norm(row.raw_description_norm))
    && (!code || !row.supplier_code || norm(row.supplier_code) === code));
  if (!matches.length || matches.some(row => row.food_id !== line.foodId)) return null;
  const stockUom = norm(line.foodUom);
  if (!stockUom) return null;
  const values = matches.map(row => {
    if (row.pack_factor == null) return { factor: 1, sourceUom: stockUom, stockUom };
    if (!Number.isFinite(row.pack_factor) || row.pack_factor <= 0
      || !row.pack_uom || norm(row.base_uom) !== stockUom) return null;
    return { factor: row.pack_factor, sourceUom: norm(row.pack_uom), stockUom };
  });
  const first = values[0];
  if (!first || values.some(value => !value || value.factor !== first.factor || value.sourceUom !== first.sourceUom)) return null;
  return first;
}
